import { create } from 'zustand';

export enum Steps {
  Objectives = 'objectives',
  Shareholders = 'shareholders',
  Directors = 'directors',
  Addons = 'addons',
  Summary = 'summary',
  Jurisdiction = 'jurisdiction',
  Checkout = 'checkout',
  Members = 'members'
}

interface OnboardingState {
  step?: Steps;
  setStep: (user: Steps) => void;
  update: boolean;
  forceUpdate: () => void;
}

const useOnboardingStore = create<OnboardingState>((set) => ({
  setStep: (step) => set(() => ({ step: step })),
  update: false,
  forceUpdate: () => set((state) => ({ update: !state.update }))
}));

export { useOnboardingStore };
